export { TagInputDropdown } from './dropdown/index';
export { DeleteIconComponent } from './icon/index';
export { TagInputForm } from './tag-input-form/index';
export { TagRipple, TagComponent } from './tag/index';
export { TagInputComponent } from './tag-input/index';
